"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tablePage = _interopRequireDefault(require("@/components/CommonForm/table-page"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "track-process",
  components: {
    TablePage: _tablePage.default
  },
  data: function data() {
    return {
      processPicUrl: '',
      tableUrl: null,
      columns: [{
        label: '环节名称',
        prop: 'activityName'
      }, {
        label: '开始时间',
        prop: 'startTime'
      }, {
        label: '结束时间',
        prop: 'endTime'
      }, {
        label: '任务历时',
        prop: 'duration'
      }, {
        label: '操作人',
        prop: 'assignee'
      }, {
        label: '审批状态',
        slot: 'status'
      }, {
        label: '审批意见',
        prop: 'comment'
      }]
    };
  },
  props: {
    processInstanceId: {
      type: String,
      required: true
    }
  },
  created: function created() {
    this.tableUrl = "flow/task/getTaskInsList?processInstanceId=".concat(this.processInstanceId);
    var time = new Date().getTime();
    this.processPicUrl = "".concat(process.env.VUE_APP_PROXY_TARGET, "flow/diagram/getTracePicByProcessInstanceId?processInstanceId=").concat(this.processInstanceId, "&time=").concat(time);
  },
  mounted: function mounted() {}
};